import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { TierCards } from "../components/TierCards";
import { useAuth } from "../context/AuthContext";
import { formatError, startCheckout, TIER_LABEL } from "../lib/api";

export default function Join() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const pre = params.get("tier");
  const [loading, setLoading] = useState(null);
  if (user?.tier) return <Navigate to="/billing" replace />;

  const onSelect = async (tier) => {
    setLoading(tier);
    try {
      await startCheckout({ kind: "tier", tier });
    } catch (e) {
      toast.error(formatError(e));
      setLoading(null);
    }
  };

  return (
    <main data-testid="join-page" className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-[140px] pb-24">
      <p className="eyebrow mb-5">{user?.tier ? "Your membership" : "Last step"}</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0E1B3D] max-w-3xl">
        {user?.tier ? <>You're a <span className="italic text-[#D7263D]">{TIER_LABEL[user.tier]}</span> member.</> : <>Pick your tier, <span className="italic text-[#D7263D]">{user?.name?.split(" ")[0] || "and"}</span> step inside.</>}
      </h1>
      <p className="mt-6 text-base text-[#4A5878] max-w-xl">
        {user?.tier ? "Upgrade any time — the new tier replaces your current subscription." : "This is a subscriber-only space. Choose a monthly tier to unlock the feed."}
        {pre && TIER_LABEL[pre] && !user?.tier && <span data-testid="join-preselected-tier"> You picked <span className="text-[#D7263D]">{TIER_LABEL[pre]}</span>.</span>}
      </p>
      <p className="mt-3 font-mono-x text-xs tracking-[0.15em] text-[#4A5878] uppercase">Secure checkout by Stripe</p>
      <div className="mt-16">
        <TierCards currentTier={user?.tier} loading={loading} onSelect={onSelect} />
      </div>
    </main>
  );
}
